import React, { useEffect, useRef } from "react";
import contenuFr from "./contenu-fr.js";
import contenuEn from "./contenu-en.js";
import { assets as assetsFr, places as placesFr } from "./donnees-fr.js";
import { assets as assetsEn, places as placesEn } from "./donnees-en.js";
import { initCarnet } from "./galerie.js";
import "./carnet.css";

/**
 * Carnet de voyage FR/EN, rendu dans le layout existant du site.
 * Le SEO (title, description, canonical, hreflang) est géré par DocumentTitle dans App.js.
 * Le layout fournit déjà un <main> : le contenu injecté n'en contient pas.
 */
export default function CarnetVoyage({ locale = "fr" }) {
  const host = useRef(null);
  const isEnglish = locale === "en";

  useEffect(() => {
    const root = host.current?.querySelector("#tanlay-carnet");
    if (!root) return undefined;
    const cleanup = initCarnet(root, isEnglish ? assetsEn : assetsFr, isEnglish ? placesEn : placesFr);
    return typeof cleanup === "function" ? cleanup : undefined;
  }, [isEnglish]);

  // Contenu éditorial statique validé : aucune donnée visiteur n'est insérée ici.
  return <div ref={host} data-testid={`page-carnet-${locale}`} dangerouslySetInnerHTML={{ __html: isEnglish ? contenuEn : contenuFr }} />;
}
